import "@/App.css";
import HomePage from "@/pages/HomePage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";

const StaticPageLoader = () => {
  const pathname = window.location.pathname.toLowerCase();

  if (pathname.endsWith("/impressum.html") || pathname.endsWith("/impressum")) {
    return <ImpressumPage />;
  }
  if (pathname.endsWith("/datenschutz.html") || pathname.endsWith("/datenschutz")) {
    return <DatenschutzPage />;
  }
  return <HomePage />;
};

function App() {
  return (
    <div className="App" data-testid="app-root">
      <StaticPageLoader />
    </div>
  );
}

export default App;
